import { fromEvent } from '#utilities/js/ea/ajax.js'
import globals from '#utilities/js/ea/globals.js'
import { shim, resolve } from '#utilities/js/ea/submitter.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { close, list } from '#utilities/js/lightboxes/menus/menu.js'
import { selector } from '../field/helpers/errors.js'

const checkbox = '[type="checkbox"][name]:not(:disabled)'
const checked = '[type="checkbox"][name]:checked:not(:disabled)'
const required = '[aria-required="true"]:not(:disabled)'

const onSubmit = object(listener, {
  type: submit,
  task: async (
    form,
    event
  ) => {
    const { submitter } = shim(event)
    const { dataset, formTarget } = submitter
    const { eaForm, target = '' } = dataset

    // @todo fb A TESTER !!!!
    if (form !== submitter.form || cancelable(form, event)) {
      return
    }

    resolve(submitter)

    if (eaForm) {
      const result = globals.ea_form(submitter, target, null)

      if (!result) {
        preventDefault(event)
        stopImmediatePropagation(event)
        globals.ea_screen_adjust()

        if (submitter.form && list(submitter)) {
          close()
        }
      }
    } else if (formTarget !== '_top') {
      preventDefault(event)
      stopImmediatePropagation(event)

      for (const helper of all(selector, form)) {
        replaceChildren(helper)
      }

      await fromEvent(form, event)

      if (submitter.form && list(submitter)) {
        close()
      }
    }
  }
})

export const cancelable = (form, event) => {
  const fieldsets = all(required, form)
  let checkboxes = new Map()

  for (const fieldset of fieldsets) {
    const first = one(checkbox, fieldset)

    if (!first || one(checked, fieldset)) {
      continue
    }

    const { required } = first

    checkboxes.set(first, required)
    first.required = true
  }

  if (checkboxes.size) {
    preventDefault(event)
    stopImmediatePropagation(event)
    form.reportValidity()

    for (const [checkbox, required] of checkboxes) {
      checkbox.required = required
    }

    return true
  }
}

export default form => {
  onSubmit.listen(form)
}
